import { Grid, TextField, Typography, Paper, Button, Stack } from '@mui/material'
import colors from '../../colors'
import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {selectForgotUserAccountState, setIsRequestSuccessfullySent } from '../../../features/login/forgotUserAccountSlice'
import { useFormik } from 'formik'
import { sendGeneralRequest } from '../../../features/generalRequest'
import { setGeneralMessage } from '../../../features/global/globalDataSlice'
import * as yup from 'yup'
import Lottie from "lottie-react";
import smallLoadingAnimation from '../../../icons/lottieAnimations/smallLoading.json'
import { ReactComponent as IconClose } from '../../../icons/closeButton.svg';
import Datepicker from '../Datepicker'
import { useNavigate } from 'react-router-dom'
import { selectUtilityState } from '../../../features/utilities/utilitySlice'
import { LocalizationProvider } from '@mui/lab';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import moment, { invalid } from 'moment';
import {texts} from '../../general/texts'

const validationSchema = yup.object({
    name: yup
        .string(texts["message-invalid-name"])
        .required(texts["message-invalid-name"]),
    surname : yup
        .string(texts["message-invalid-last-name"])
        .required(texts["message-invalid-last-name"]),
    phone: yup
        .string(texts["message-invalid-phone"]),
    birthDate : yup
        .string(texts["message-invalid-birthdate"])
        // .matches(/^[0-9]{2}[\/][0-9]{2}[\/][0-9]{4}$/,{
        //     message:'Vendosni formatin e sakte : DD/MM/YYYY'
        // })
        .nullable()
        .required(texts["message-invalid-birthdate"])
        
})

const ForgotUser = () =>{

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const utilitySliceState = useSelector(selectUtilityState) 
    const forgotUserAccountSliceState = useSelector(selectForgotUserAccountState)

    const formik = useFormik({
        initialValues:{
            name:'',
            surname:'',
            phone:'',
            birthDate :''
        },
        validateOnChange:'false',
        validateOnBlur:'false',
        validationSchema: validationSchema,
        onSubmit: values => {
            dispatch(sendGeneralRequest({request: {_request: {...values, birthDate: moment(values.birthDate).format('DD/MM/yyyy')}}, baseUrlKey:'auth', endpoint:'UserLostAccount'}))
        }
    })

    const handleBirthdateChange = (value) => {
        formik.setFieldValue('birthDate', value)
    }

    React.useEffect(()=>{
        if(forgotUserAccountSliceState.isRequestSuccessfullySent)
        {
            dispatch(setGeneralMessage({type: 'success', message: texts["message-success-forgot-data"]}))
            dispatch(setIsRequestSuccessfullySent(false))
            // navigate('/requestSent')
        }
    }, [forgotUserAccountSliceState.isRequestSuccessfullySent])


  return (
      <form>
        <Grid container justifyContent='center' width={'100%'}>
            <Grid container item md={8} xs={10} justifyContent={'right'} pt={10}>
                <Button sx={{fontSize:'1.8rem', color:colors.orange, borderRadius:'20px', ':hover': {background:colors.white}}} onClick={() => {navigate('/forgotUserMain')}} ><IconClose /></Button>
             </Grid>
             <Grid container pt={15} rowSpacing={3} >
                 <Grid container item md={12} justifyContent={"center"} >
                     <Typography sx={{color:colors.darkBlue, fontSize:'2rem', fontFamily:'GerberaBold'}}>{texts["button-forgot-data"]}</Typography>
                 </Grid>
                 <Grid container item md={12} justifyContent={"center"} >
                     <Typography sx={{color:colors.gray, fontSize:"1.3rem", fontFamily:'GerberaMedium'}}>{texts["message-complete-fields"]}</Typography>
                 </Grid>
             </Grid>
            <Grid container item pt={15} sx={{width:'60%','@media (max-width: 1440px)':{width:'70%'},'@media (max-width: 1024px)':{width:'85%'},'@media (max-width: 768px)':{width:'80%'},'@media (max-width: 425px)':{width:'90%'}}} pl={'9.5%'}  >
                <Grid container item md={6} xs={12} flexDirection='column' marginBottom={10}>
                    <Grid container item justifyContent='flex-start' mb={2}>
                        <Typography sx={{color: colors.orange, fontSize:'1.2rem', fontFamily:'GerberaMedium'}} >{texts["dialog-name"]}</Typography></Grid>
                    <Grid container item justifyContent='flex-start'><TextField id="name" name="name" onChange={formik.handleChange} value={formik.values.name} error={formik.touched.name && Boolean(formik.errors.name)} helperText={formik.touched.name && formik.errors.name} color="warning" variant="standard"  sx={{width:'15vw','@media (max-width: 899px)':{width:'50vw'}}} /></Grid>         
                </Grid>
                <Grid container item md={6} xs={12} flexDirection='column'>
                    <Grid container item justifyContent='flex-start' mb={2}><Typography sx={{color: colors.orange, fontSize:'1.2rem', fontFamily:'GerberaMedium'}} >{texts["dialog-lastname"]}</Typography></Grid>
                    <Grid container item justifyContent='flex-start' mb={2}><TextField id="surname" name="surname" onChange={formik.handleChange} value={formik.values.surname} error={formik.touched.surname && Boolean(formik.errors.surname)} helperText={formik.touched.surname && formik.errors.surname} color="warning" variant="standard" sx={{width:'15vw','@media (max-width: 899px)':{width:'50vw'}}} /></Grid>    
                </Grid>
                <Grid container item md={6} xs={12} flexDirection='column' marginBottom={10}>
                    <Grid container item justifyContent='flex-start' mb={2}>
                        <Typography sx={{color: colors.orange, fontSize:'1.2rem', fontFamily:'GerberaMedium'}} >{texts["placeholder-phone-number"]}</Typography></Grid>
                    <Grid container item justifyContent='flex-start'><TextField id="phone" name="phone" onChange={formik.handleChange} value={formik.values.phone} error={formik.touched.phone && Boolean(formik.errors.phone)} helperText={formik.touched.phone && formik.errors.phone} color="warning" placeholder="6########" variant="standard" sx={{width:'15vw','@media (max-width: 899px)':{width:'50vw'}}} /></Grid>         
                </Grid>
                <Grid container item md={6} xs={12} flexDirection='column'>
                    <Grid container item justifyContent='flex-start' mb={2}><Typography sx={{color: colors.orange, fontSize:'1.2rem', fontFamily:'GerberaMedium'}} >{texts["title-registration-birthdate"]}</Typography></Grid>
                    <Grid container item justifyContent='flex-start' mb={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack>
                            <DesktopDatePicker
                            inputFormat="dd/MM/yyyy"
                            openTo="day"
                            views={['day', 'month', 'year']}
                            value={formik.values.birthDate} 
                            id='birthDate' name='birthDate' onChange={handleBirthdateChange}
                            renderInput={(params) => <TextField id='birthDate' name='birthDate' variant="standard"  placeholder='dd/mm/yyyy' color={'warning'} helperText={formik.touched.birthDate && formik.errors.birthDate}  {...params} error={formik.touched.birthDate && Boolean(formik.errors.birthDate)} sx={{width:'15vw','@media (max-width: 899px)':{width:'50vw'}}} />}
                            />
                        </Stack>
                    </LocalizationProvider>    
                    </Grid>
                </Grid>
            </Grid>
            <Grid container item md={12} xs={12} justifyContent={'center'} pb={2} >
                <Button disabled={forgotUserAccountSliceState.isLoading ? true : false} onClick={formik.handleSubmit} sx={{background:colors.gradientOrange, color:colors.white, fontSize:'1rem', fontFamily:'GerberaBold',textTransform:'none', width:'10%','@media (max-width: 899px)' : {width:'30%'}}} >{texts["button-continue"]}</Button>
            </Grid>
            <Grid container justifyContent={'center'} >
                <Grid container item md={1} xs={1} >
                    {forgotUserAccountSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}    
                </Grid>
            </Grid>         
        </Grid>
      </form>
    )
}
export default ForgotUser

{/* <MobileDatePicker
                            DialogProps={{
                                PaperProps:{
                                    sx:{
                                        "& .MuiPaper-root": {
                                            background:colors.white,
                                            "& .MuiPaper-rounded":{
                                                borderRadius:'20px'
                                            },
                                          },
                                          "& .MuiCalendarPicker-root": {
                                            background:colors.white,
                                            
                                            "&.Mui-selected": {
                                                background:colors.orange,
                                                ':hover':{background:colors.orange},
                                              },
                                              "& .PrivatePickersYear-yearButton":{
                                                background:colors.lightOrange,
                                                ':hover':{background:colors.orange},
                                                "&.Mui-selected": {
                                                    backgroundColor:colors.orange,
                                                    ':hover':{background:colors.orange},
                                                  },
                                              },
                                              "& .MuiPickersDay-dayWithMargin": {
                                                background:colors.lightOrange,
                                                ':hover':{background:colors.orange},
                                                "&.Mui-selected": {
                                                    background:colors.orange,
                                                    ':hover':{background:colors.orange},
                                                  },
                                              },
                                              "& .PrivatePickersMonth-root":{
                                                background:colors.lightOrange,
                                                ':hover':{background:colors.orange},
                                                "&.Mui-selected": {
                                                    background:colors.orange,
                                                    ':hover':{background:colors.orange},
                                                  },
                                              },
                                          },
                                          
                                          "& .MuiButton-root":{
                                            background:colors.gradientOrange,
                                            fontFamily:'GerberaLight',
                                            fontSize:'0.8rem',
                                            textTransform:'none',
                                            color:colors.white,
                                            borderRadius:'20px'
                                          },
                                          "& .PrivatePickersToolbar-root":{
                                            display:'none'
                                          }
                                }
                            }}}
                            openTo="year"
                            fullWidth={true}
                            inputFormat="dd/MM/yyyy"
                            views={['year', 'month', 'day']}
                            value={formik.values.birthDate} 
                            id='birthDate' name='birthDate' onChange={handleBirthdateChange}  color={'warning'}
                            renderInput={(params) => 
                            <TextField  id='birthDate' name='birthDate' variant="standard"  placeholder='dd/mm/yyyy' color={'warning'} helperText={formik.touched.birthDate && formik.errors.birthDate}  {...params} error={formik.touched.birthDate && Boolean(formik.errors.birthDate)} sx={{width:'15vw','@media (max-width: 899px)':{width:'50vw'}}} />}
                            /> */}